module.exports = __webpack_public_path__ + "static/3999_Cavestri_Cir-36163a0ff6a442ba48f612b89b4a302f.jpg";